<div class="container mt-3">
       <form [formGroup]="patientForm" (ngSubmit)="onSubmit()">

       

        <div class="p-fluid formgrid grid">
            <div class="field col-12 md:col-4">
                <span class="p-float-label pl-3">
                    <input id="lastname"
                           type="text"
                           appFormErrorMessages
                           pInputText
                           formControlName="lastName"
                           class="textboxBorder-1" />
                    <label for="float-input" class="f1">
                        <span class="required-asteric"> * </span> Last Name
                    </label>
                </span>
            </div>
            <div class="field col-12 md:col-4">
                <span class="p-float-label pl-3">
                    <input id="firstname"
                           type="text"
                           appFormErrorMessages
                           pInputText
                           formControlName="firstName"
                           class="textboxBorder-1" />
                    <label for="float-input" class="f1">
                        <span class="required-asteric"> * </span> First Name
                    </label>
                </span>
            </div>
            <div class="field col-12 md:col-4">
                <span class="p-float-label pl-2">
                    <input id="middlename"
                           type="text"
                           pInputText
                           formControlName="middleName"
                           class="textboxBorder-1"
                           appFormErrorMessages />
                    <label for="float-input" class="f1"> Middle Name</label>
                </span>
            </div>
        </div>

        <div class="p-fluid formgrid grid">
            <div class="field col-12 md:col-4">
                <span class="p-float-label pl-3">
                    <p-dropdown id="ddlGender"
                                [options]="genderOptions"
                                appFormErrorMessages
                                editable="false"
                                placeholder="Select Gender"
                                class="textboxBorder-1"
                                optionLabel="value"
                                optionValue="key"
                                dataKey="value"
                                formControlName="gender">

                    </p-dropdown>
                    <label for="ddlRole" class="f1">
                        <span class="required-asteric"></span> Gender
                    </label>
                </span>
            </div>
            <div class="field col-12 md:col-4">
                <span class="p-float-label pl-2">
                    <input id="homeAddressLine1"
                           type="text"
                           appFormErrorMessages
                           pInputText
                           formControlName="homeAddressLine1"
                           class="textboxBorder-1"
                           autocomplete="off" />
                    <label for="float-input" class="f1">
                        Address Line
                    </label>
                </span>
            </div>

            <div class="field col-12 md:col-4">
                <span class="p-float-label pl-3">

                    <input id="homeTelephone"
                           type="text"
                           appFormErrorMessages
                           pInputText
                           formControlName="homeTelephone"
                           class="textboxBorder-1"
                           autocomplete="off" />
                    <label for="float-input" class="f1">
                        Telephone (H)
                    </label>
                </span>
            </div>


            

        </div>
        <div class="p-fluid formgrid grid">

            <div class="field col-12 md:col-3">
                <span class="p-float-label pl-3">

                    <input id="homeState"
                           type="text"
                           appFormErrorMessages
                           pInputText
                           formControlName="homeState"
                           class="textboxBorder-1"
                           autocomplete="off" />
                    <label for="float-input" class="f1">
                        State
                    </label>
                </span>
            </div>


            <div class="field col-12 md:col-3">
                <span class="p-float-label pl-3">

                    <input id="homePostalCode"
                           type="text"
                           appFormErrorMessages
                           pInputText
                           formControlName="homePostalCode"
                           class="textboxBorder-1"
                           autocomplete="off" />
                    <label for="float-input" class="f1">
                        Postal Code
                    </label>
                </span>
            </div>
            <div class="field col-12 md:col-3">
                <span class="p-float-label pl-3">
                    <input id="homeCountry"
                           type="text"
                           appFormErrorMessages
                           pInputText
                           formControlName="homeCountry"
                           class="textboxBorder-1"
                           autocomplete="off" />
                    <label for="float-input" class="f1">
                        Country
                    </label>
                </span>
            </div>

            <div class="field col-12 md:col-3">
                <span class="p-float-label pl-3">

                    <input id="homeCity"
                           type="text"
                           appFormErrorMessages
                           pInputText
                           formControlName="homeCity"
                           class="textboxBorder-1"
                           autocomplete="off" />
                    <label for="float-input" class="f1">
                        City
                    </label>
                </span>
            </div>







        </div>

        <div class="col-6 md:col-6 mt-2">
            <button pButton type="submit" label="Update" icon="pi pi-save" class="p-button-plain buttonWidth-8 fl"></button>&nbsp;
            <button pButton type="button" label="Cancel" class="p-button-secondary" (click)="onCancelClick()"></button>
        </div>
    </form>
</div>
